var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.275 3.5C2.01641 3.5 1.76842 3.38938 1.58557 3.19246C1.40272 2.99555 1.3 2.72848 1.3 2.45C1.3 2.17152 1.40272 1.90445 1.58557 1.70754C1.76842 1.51062 2.01641 1.4 2.275 1.4C2.53359 1.4 2.78158 1.51062 2.96443 1.70754C3.14728 1.90445 3.25 2.17152 3.25 2.45C3.25 2.72848 3.14728 2.99555 2.96443 3.19246C2.78158 3.38938 2.53359 3.5 2.275 3.5ZM12.6165 6.706L6.7665 0.406C6.5325 0.154 6.2075 0 5.85 0H1.3C0.5785 0 0 0.623 0 1.4V6.3C0 6.685 0.143 7.035 0.3835 7.287L6.227 13.587C6.4675 13.839 6.7925 14 7.15 14C7.5075 14 7.8325 13.839 8.0665 13.587L12.6165 8.687C12.857 8.435 13 8.085 13 7.7C13 7.308 12.8505 6.958 12.6165 6.706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.20e02ec2db1c351aea36c6acd0b65b5a.svg";
export { ForwardRef as ReactComponent };